module.exports = __webpack_public_path__ + "static/media/caleta-en-linea-nuevo-logo.f01c0867.jpg";